var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoSquareGrey = function SvgLogoSquareGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 77,
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 78,
    height: 77
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0h77.49v76.306H0V0Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.49 0H14.049C6.289 0-.001 6.29-.001 14.047v62.259h77.49V0Z",
    fill: "#B7B7B7"
  }))));
};
export { SvgLogoSquareGrey as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzgiIGhlaWdodD0iNzciIHZpZXdCb3g9IjAgMCA3OCA3NyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swXzYyNl8zMDAyMSIgc3R5bGU9Im1hc2stdHlwZTphbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMCIgeT0iMCIgd2lkdGg9Ijc4IiBoZWlnaHQ9Ijc3Ij4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wIDBINzcuNDg5NVY3Ni4zMDU5SDBWMFoiIGZpbGw9IndoaXRlIi8+CjwvbWFzaz4KPGcgbWFzaz0idXJsKCNtYXNrMF82MjZfMzAwMjEpIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03Ny40ODk1IDBIMTQuMDQ4NUM2LjI4OTcyIDAgLTAuMDAwNTg3NDYzIDYuMjkwMjggLTAuMDAwNTg3NDYzIDE0LjA0NzFWNzYuMzA1OUg3Ny40ODk1VjBaIiBmaWxsPSIjQjdCN0I3Ii8+CjwvZz4KPC9zdmc+Cg==";